import get from 'lodash/get';

export function getAdmissionContact(collegeData) {
  const overview = get(collegeData, 'fullProfile.overview');
  const admissionsOffice = get(overview, 'admissionsOffice');
  const schoolName = get(overview, 'schoolName.value');
  const firstName = get(admissionsOffice, 'firstName.value');
  const middleName = get(admissionsOffice, 'middleName.value');
  const lastName = get(admissionsOffice, 'lastName.value');
  const attn = `${firstName} ${middleName} ${lastName}`.replace(/ {2}/g, ' ');
  const phone = get(admissionsOffice, 'phoneNumber.value');
  const fax = get(admissionsOffice, 'fax.value');
  const financialAid = get(overview, 'financialAid.phoneNumber.value');
  const email = get(admissionsOffice, 'email.value');
  return {
    schoolName,
    attn,
    phone,
    fax,
    financialAid,
    email,
  };
}
